const forumBannerOne: adUnit = {
  element: "forum_banner_1",
  gamCode: "/21841313772,22653506037/wso/forum_banner_1",
  sizes: {
    mobile: [[300, 250]],
    tablet: [[300, 250]],
    desktop: [[728, 90]],
  },
  sizeMapping: [
    {
      viewPortSize: [1251, 250],
      sizes: [[728, 90]],
    },
    {
      viewPortSize: [728, 250],
      sizes: [[300, 250]],
    },
    {
      viewPortSize: [0, 0],
      sizes: [[300, 250]],
    },
  ],
  vendors: {
    amazon: true,
    prebid: {
      enabled: true,
      mediaTypes: {
        banner: {
          sizeConfig: [
            { minViewPort: [0, 0], sizes: [[300, 250]] },
            { minViewPort: [992, 0], sizes: [[300, 250]] },
            { minViewPort: [1251, 0], sizes: [[728, 90]] },
          ],
        },
      },
      bids: [
        {
          bidder: 'equativ',
          params: {
            networkId: 5632,
          },
        },
        {
          bidder: "ix",
          params: {
            siteId: "957617",
          },
        },
        {
          bidder: "medianet",
          params: {
            cid: "8CUZX691M",
            crid: "946235146",
          },
        },
        {
          bidder: "nativo",
          params: {
            placementId: 1467949,
          },
        },
        {
          bidder: "oms",
          params: {
            publisherId: 20931,
          },
        },
        {
          bidder: "onetag",
          params: {
            pubId: "76b2c6676b744dc",
          },
        },
        {
          bidder: "pubmatic",
          params: {
            publisherId: "158347",
            adSlot: "4968126",
          },
        },
        {
          bidder: "rubicon",
          params: {
            accountId: "20438",
            siteId: "470922",
            zoneId: "2787316",
          },
        },
        {
          bidder: "sovrn",
          params: {
            tagid: "1232483", // 300x250
          },
          sizeConfig: [
            { minViewPort: [0, 0], relevantMediaTypes: ["banner"] },
            { minViewPort: [768, 0], relevantMediaTypes: ["banner"] },
            { minViewPort: [1251, 0], relevantMediaTypes: ["none"] },
          ],
        },
        {
          bidder: "sovrn",
          params: {
            tagid: "1116268", // 728x90
          },
          sizeConfig: [
            { minViewPort: [0, 0], relevantMediaTypes: ["none"] },
            { minViewPort: [768, 0], relevantMediaTypes: ["none"] },
            { minViewPort: [1251, 0], relevantMediaTypes: ["banner"] },
          ],
        },
        {
          bidder: "nobid",
          params: {
            siteId: 198057,
          },
        },
      ],
    },
  },
};

export default forumBannerOne;
